import { apiEndpoints } from "@/services/api/api";
import { ForgotPasswordEnterEmailActionResponse } from "../types/forgotPasswordEnterEmailTypes";
import { redirect } from "react-router-dom";
import { eventBus } from "@/services/event/eventBus";

export async function forgotPasswordEnterEmailAction({
  request,
}: {
  request: Request;
}) {
  const formData = await request.formData();
  const email = formData.get("email") as string;
  if (!email) {
    eventBus.emit("notify", {
      type: "error",
      message: "Lütfen e-posta adresinizi giriniz.",
    });
    throw redirect("/forgot-password");
  }
  // TO DO Result'a type verilecek. Error handling yapılacak.
  const result = await apiEndpoints.sendResetPasswordEmail(email);
  if (result.success) {
    return {
      email: email,
      shouldRedirect: true,
    } satisfies ForgotPasswordEnterEmailActionResponse;
  }
}
